export const actionTypes = {
  MODIFY_SELECTED_REPORT: "MODIFY_SELECTED_REPORT",

  //CALL
  REPORTS_REQUEST: "REPORTS_REQUEST",
  REPORTS_REQUEST_SUCCESS: "REPORTS_REQUEST_SUCCESS",
  REPORTS_REQUEST_FAILURE: "REPORTS_REQUEST_FAILURE",
  REPORT_REQUEST: "REPORT_REQUEST",
  REPORT_REQUEST_SUCCESS: "REPORT_REQUEST_SUCCESS",
  REPORT_REQUEST_FAILURE: "REPORT_REQUEST_FAILURE",

  REPORT_GENERATE: "REPORT_GENERATE",
  REPORT_GENERATE_SUCCESS: "REPORT_GENERATE_SUCCESS",
  REPORT_GENERATE_FAILURE: "REPORT_GENERATE_FAILURE",

  REPORT_VALUE: "REPORT_VALUE",
  ADD_REPORT_INPUT: "ADD_REPORT_INPUT",

  REPORTS_CAMPAIGNS_NAMES_REQUEST: "REPORTS_CAMPAIGNS_NAMES_REQUEST",
  REPORTS_CAMPAIGNS_NAMES_REQUEST_SUCCESS:
    "REPORTS_CAMPAIGNS_NAMES_REQUEST_SUCCESS",
  REPORTS_CAMPAIGNS_NAMES_REQUEST_FAILURE:
    "REPORTS_CAMPAIGNS_NAMES_REQUEST_FAILURE",

  //RESET
  REPORT_RESET_STATE: "REPORT_RESET_STATE",
};

export const modifySelectedReport = (payload: {}) => ({
  type: actionTypes.MODIFY_SELECTED_REPORT,
  payload,
});

export const reportsRequest = () => ({
  type: actionTypes.REPORTS_REQUEST,
});

export const reportsRequestSuccess = (payload: any) => ({
  type: actionTypes.REPORTS_REQUEST_SUCCESS,
  payload,
});

export const reportsRequestFailure = (err: any) => ({
  type: actionTypes.REPORTS_REQUEST_FAILURE,
  err,
});

export const reportRequest = () => ({
  type: actionTypes.REPORT_REQUEST,
});

export const reportRequestSuccess = (payload: any) => ({
  type: actionTypes.REPORT_REQUEST_SUCCESS,
  payload,
});

export const reportRequestFailure = (err: any) => ({
  type: actionTypes.REPORT_REQUEST_FAILURE,
  err,
});

export const reportGenerate = (payload: any) => ({
  type: actionTypes.REPORT_GENERATE,
  payload,
});

export const reportGenerateSuccess = () => ({
  type: actionTypes.REPORT_GENERATE_SUCCESS,
});

export const reportGenerateFailure = () => ({
  type: actionTypes.REPORT_GENERATE_FAILURE,
});

export const reportValue = (payload: any) => ({
  type: actionTypes.REPORT_VALUE,
  payload,
});

export const addReportInput = (payload: any) => ({
  type: actionTypes.ADD_REPORT_INPUT,
  payload,
});

export const reportCampaignNameRequest = (payload: any) => ({
  type: actionTypes.REPORTS_CAMPAIGNS_NAMES_REQUEST,
  payload,
});

export const reportCampaignNameRequestSuccess = (payload: any) => ({
  type: actionTypes.REPORTS_CAMPAIGNS_NAMES_REQUEST_SUCCESS,
  payload,
});

export const reportCampaignNameRequestFailure = (payload: any) => ({
  type: actionTypes.REPORTS_CAMPAIGNS_NAMES_REQUEST_FAILURE,
  payload,
});

//RESET
export const reportResetState = () => ({
  type: actionTypes.REPORT_RESET_STATE,
});
